import React from 'react';

const Spinner = () => (
    <div className="spinner captions-spinner">
        <div className="amplify-spinner spinner-centered spinner-small spinner-dark">
            <div className="loader" />
        </div>
    </div>
);

export default Spinner;
